import { getDocumentCookie } from '@Praia-Health/spi-common-utils/browser';
import { setBrowserCookie } from '../util/browserCookie';

export const CORRELATION_ID_HEADER = 'correlation-id';
const CLIENT_CORRELATION_ID_COOKIE = 'correlationId';
export const QUERY_PARAMETER_PLATFORM = 'platform';
export const QUERY_PARAMETER_CLIENT = 'client_app';
// We want to add the query parameters 'device' and 'client' to the logs.
export function storeLogMetadata(): void {
    readQueryParameter(QUERY_PARAMETER_CLIENT);
    readQueryParameter(QUERY_PARAMETER_PLATFORM);
}

function readQueryParameter(key: string): void {
    const searchParams = new URLSearchParams(document.location.search);
    const queryParameter = searchParams.get(key);
    if (queryParameter) {
        window.sessionStorage.setItem(key, queryParameter);
    }
}

export function setClientCorrelationId(correlationId: string): void {
    setBrowserCookie(CLIENT_CORRELATION_ID_COOKIE, correlationId);
}

// get from cookie or use uuidv4
export function getClientCorrelationId(): string {
    let correlationId = getDocumentCookie(document.cookie, CLIENT_CORRELATION_ID_COOKIE);
    if (!correlationId) {
        try {
            correlationId = globalThis.crypto.randomUUID();
        } catch {
            console.log('getClientCorrelationId(): not supported');
        }
    }
    return correlationId as string;
}
